import rolesAPI from '@/api/resources/roles'

const state = {
  all: []
}

const getters = {
  allRoles: state => state.all,
  getRoleById: (state, getters) => (id) => {
    return state.all.find(role => role.id === id)
  },
  getRoleNamesByIds: (state, getters) => (roles) => {
    return roles.reduce((acc, r) => {
      let p = getters.getRoleById(r.id)
      if (p) {
        return acc + ' ' + r.name
      }
    }, '')
  }
}

const actions = {
  getAllRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      rolesAPI.loadRoles().then(result => {
        commit('receivedRoles', result)
        resolve()
      })
    })
  }
}

const mutations = {
  receivedRoles (state, roles) {
    state.all = roles
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/roles.js